export function resolveSingularName(passedName, tableName) {
  // 1. Use explicitly passed name if present
  if (passedName && passedName.trim().length > 0) {
    return passedName;
  }

  // 2. Fallback to tableName logic
  if (!tableName) return "";

  // Remove "v_" prefix if present
  let cleaned = tableName.startsWith("v_") ? tableName.slice(2) : tableName;

  // Replace underscores with spaces
  cleaned = cleaned.replace(/_/g, " ");

  // 3. Singularize (basic: remove trailing 's')
  if (cleaned.endsWith("s")) {
    cleaned = cleaned.slice(0, -1);
  }

  // 4. Capitalize each word
  cleaned = cleaned.replace(/\b\w/g, (char) => char.toUpperCase());

  return cleaned;
}
